import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'ricerca-generica-anagrafiche',
  templateUrl: './ricerca-generica-anagrafiche.component.html',
  styleUrls: ['./ricerca-generica-anagrafiche.component.scss']
})
export class RicercaGenericaAnagraficheComponent implements OnInit {

  @Output() search = new EventEmitter();

  constructor(
    private fb: FormBuilder,

  ) { }

  form: FormGroup;

  ngOnInit(): void {
    this.form = this.fb.group({
      nome: [],
      via: [],
      civico: [],
      comune: [],
      tel: [],
      fax: [],
      cell: [],
      email: [],
    });

    this.form.valueChanges.subscribe(() => this.search.emit(this.form.value));

  }

}
